export const relayFields = [
  'zipCode',
  'country',
  'city',
  'id',
  'name',
  'geoPoint(latitude, longitude)',
  'street',
  'provider'
];
